export default __webpack_public_path__ + "static/media/ic_report.72994632.svg";